module.exports = __webpack_public_path__ + "static/media/Bell_beaker_lba_scotland_200px.35e541a8.png";